<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
  >
    <div
      id="page-loader"
      class="bg-gd-aqua"
      :class="loading ? 'show' : 'false'"
    ></div>
    <header-component></header-component>
    <sidebar-component></sidebar-component>
    <main id="main-container">
      <div class="bg-light" v-if="success">
        <div class="hero">
          <div class="hero-inner">
            <div class="content content-full text-center">
              <h1
                class="display-4 font-w700 mb-3 js-appear-enabled animated fadeInDown"
                data-toggle="appear"
                data-class="animated fadeInDown"
              >
                Arx<span class="text-primary">editor</span>
              </h1>
              <h2
                class="font-w300 text-muted mb-5 js-appear-enabled animated fadeInUp"
                data-toggle="appear"
                data-class="animated fadeInUp"
                data-timeout="400"
              >
                Your application has just send.
              </h2>
              <div
                class="js-appear-enabled animated fadeInUp"
                data-toggle="appear"
                data-class="animated fadeInUp"
                data-timeout="800"
              >
                <a
                  class="btn btn-hero-primary"
                  href="javascript:void(0)"
                  @click="reload()"
                >
                  <i class="fa fa-fw fa-arrow-right mr-1"></i> New Application
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="!success">
        <form @submit.prevent="sendForm" id="formAction" class="aanvraagstraatFormGtm">
          <div class="row">
            <div class="col-12" v-if="isCreated">
              <ActionForm
                :data="form.data"
                :isValidSubmit="isValidSubmit"
                isValidSubmittedData
              ></ActionForm>
            </div>
          </div>
          <div class="row">
            <div class="col-12"></div>
          </div>
        </form>
      </div>
    </main>
    <nav
      class="navbar navbar-light p-4 mt-4 w-100"
      style="background-color: #ffa400 !important; font-size: 16px"
    >
      <div class="container">
        <a href="/" class="navbar-brand text-dual"
          ><span class="font-w300 text-white">Copyright© 2020</span>
          <span class="font-w300 text-white">ARX</span></a
        >
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import HeaderComponent from "../components/layout/Header";
import SidebarComponent from "../components/layout/Sidebar";
import { SetSubmittedDefaults } from "./Mixins/SetSubmittedDefaults";
import { LanguageMixin } from "./Mixins/LanguageMixin";
import { GetFormMixin } from "./Mixins/GetFormMixin";
import { SendFormMixin } from "./Mixins/SendFormMixin";
import { SetMortgageSubmitted } from "./Mixins/SetMortgageSubmitted";

import ActionForm from "./ActionForm";
export default {
  name: "SubmittedForm",
  mixins: [
    SetSubmittedDefaults,
    LanguageMixin,
    GetFormMixin,
    SendFormMixin,
    SetMortgageSubmitted
  ],
  components: {
    ActionForm,
    SidebarComponent,
    HeaderComponent
  },
  props: {
    isValidSubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      success: false,
      isCreated: false,
      notFound: false,
      notFoundErrorMessage: ""
    };
  },
  async created() {
    await this.getTranslate();
    const res = await this.getFormData({
      id: this.$route.params.submitid,
      type: "auth"
    });
    const res2 = await this.getFormById({
      id: res,
      type: "noauth",
      isShow: true,
      isSubmitted: true
    });
    await this.setLanguage();
    await this.setSubmittedDefaults();
    await this.setMortgageSubmitted();
    this.setSuccessOrError(res2);
    if (
      this.selectedProducts.includes(2) &&
      !this.selectedProducts.includes(1)
    ) {
      setTimeout(() => {
        this.setRates(2);
        this.$forceUpdate();
      }, 200);
    }
  },
  computed: {
    ...mapState({
      SubmitData: state => state.forms.SubmitData
    })
  },
  methods: {
    ...mapMutations({
      setFamilySituation: "forms/SET_FAMILY_SITUATION"
    }),
    ...mapActions({
      getFormData: "forms/getFormData",
      getFormById: "forms/getFormById",
      getTranslate: "translate/getTranslate"
    }),
    reload() {
      window.location.reload();
    }
  }
};
</script>
